import { createIcon } from "@chakra-ui/react";
import * as React from "react";

const CircleDocument = createIcon({
  path: (
    <path
      d="M10 20C4.48209 20 0 15.5179 0 10C0 4.48209 4.48209 0 10 0C15.5179 0 20 4.48209 20 10C20 15.5179 15.5179 20 10 20ZM7.62827 15.3437H12.8074C13.9303 15.3437 14.5015 14.7531 14.5015 13.6302V9.41917H10.5227C9.86447 9.41917 9.54501 9.09971 9.54501 8.43175V4.40465H7.62827C6.50532 4.40465 5.92449 4.99516 5.92449 6.1181V13.6302C5.92449 14.7628 6.50532 15.3437 7.62827 15.3437ZM10.668 8.57696H14.4434C14.4143 8.34463 14.2498 8.11229 13.969 7.84124L11.1036 4.9274C10.8422 4.65634 10.6002 4.48209 10.3679 4.45305V8.28654C10.3679 8.48015 10.4743 8.57696 10.668 8.57696Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 20 20",
});

export { CircleDocument };
